var lists_default = {
  "fontElementMap": "os2f2",
  "orderedlist": "nwwU4",
  "bulletedlist": "sLt9m",
  "listItem": "gxRIe"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
